// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"a2f459f1","533":"72134928","760":"c9151673"}[chunkId] + ".js";
};